import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormControl } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CatalogPriceRulesService } from 'src/app/services/catalog-price-rules.service';
import { CmsPageService } from 'src/app/services/cms-page.service';
import { CommonService } from 'src/app/services/common.service';
import { DealStatusService } from 'src/app/services/deal-status.service';
import { DoctorService } from 'src/app/services/doctor-service.service';
import { DynamicFormGroupService } from 'src/app/services/dynamic-form-group.service';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { LecturerService } from 'src/app/services/lecturer.service';
import { PriorityService } from 'src/app/services/priority.service';
import { ProductService } from 'src/app/services/product.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { SizechartService } from 'src/app/services/sizechart.service';
import { StatusService } from 'src/app/services/status.service';
import { SupplierService } from 'src/app/services/supplier.service';
import { TaxService } from 'src/app/services/tax.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { UsersService } from 'src/app/services/users.service';
import { FieldConfig } from 'src/app/shared/dynamic-form/field-interface';

@Component({
  selector: 'calsoft-select-lead-form',
  templateUrl: './select-lead-form.component.html',
  styleUrls: ['./select-lead-form.component.scss']
})
export class SelectLeadFormComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';



  @Input() attributeMap = new Map<any, any>();

  @Input() attributeCode = new Map<any, any>();

  @Input() frontEndLabel: any;

  @Input() frontEndLabelChange: any = 0;

  field: FieldConfig['eavAttribute'];
  @Input() group: UntypedFormGroup;
  Option: any;
  fieldTypeList: any;

  value: any;

  newType: any = 1;
  filteredcountryTypeList: any;
  countryTypeList: any;
  countryControl: UntypedFormControl = new UntypedFormControl();
  countryFilterControl: UntypedFormControl = new UntypedFormControl();

  filteredTaxClassList: any;
  taxClassTypeList: any;
  taxclassControl: UntypedFormControl = new UntypedFormControl();
  taxclassFilterControl: UntypedFormControl = new UntypedFormControl();

  supDisabled: boolean = false;
  protected _onDestroy = new Subject<void>();
  searchTermValue: string;
  firstFormGroup: UntypedFormGroup
  categoryId: any;
  sizeChart: Object;
  display: boolean;
  spinner: boolean;

  constructor(
    private commonService: CommonService,
    private ecryptService: EcryptServiceService,
    private taxService: TaxService,
    private supplierService: SupplierService,
    private sizechartService: SizechartService,
    private leadSourceService: LeadSourceService,
    private leadStatusService: LeadStatusService,
    private usersService: UsersService,
    private cmsPageService: CmsPageService,
    private lecturerService: LecturerService,
    private doctorService: DoctorService,
    private catalogPriceRulesService: CatalogPriceRulesService,
    public productService: ProductService,
    private dynamicFormLabelService: DynamicFormLabelService,
    private dynamicFormGroupService: DynamicFormGroupService,
    private priorityService: PriorityService,
    private trackerService: TrackerService,
    private projectsService: ProjectsService,
    private router: Router,
    private statusService: StatusService,
    private dealStatusService: DealStatusService,

  ) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }
  productInit: any = false;
  technicianId: any = 0;


  ngOnInit() {

    console.log(this.group);



    this.field = this.attributeMap.get(this.attributeCode);

    if (this.frontEndLabelChange != 1) {

      this.frontEndLabel = this.field.frontendLabel;
    }
    if (this.field.frontendLabel == 'Product') {


      let value = this.group.value.Category;


      if (value != undefined) {

        if (value > 0) {
          this.setCategoryNew(value);
          this.productInit = true;
        }


      }





      this.group.get('Category')?.valueChanges.subscribe(value => {
        console.log('Name changed:', value);

        this.setCategoryNew(value);
      });
    }

    this.countrYFilter();
    this.getAllCountry();
    this.getAllField();
    this.fielDFilter();
    this.getAllTaxclass();

    this.taxclassYFilter();

    this.PriorityYFilter();
    this.getAllPriority();

    if (this.router.url.includes('/product') && this.field.frontendLabel == 'Status') {
      this.Option = [
        { regionId: 1, defaultName: 'Enabled' },
        { regionId: 0, defaultName: 'Disabled' },
      ]
    }
    else if (this.field.frontendLabel == 'Visibility') {
      this.Option = [
        { regionId: 1, defaultName: 'not visible individually' },
        { regionId: 2, defaultName: 'catalog' },
        { regionId: 3, defaultName: 'search' },
        { regionId: 4, defaultName: 'catalog,search' }
      ]
    }
    else if (this.field.frontendLabel == 'Country of Manufacture') {
      this.commonService.getCountryList().subscribe(
        res => {
          this.countryTypeList = res;
          this.filteredcountryTypeList = this.countryTypeList;
        },
        error => {
        }
      )
    }
    else if (this.field.frontendLabel == 'sizeChart') {
      this.field.eavAttributeOption = [];
      this.sizechartService.getAllSizeChartDropDown().subscribe(
        res => {
          this.sizeChart = res;
          // this.filteredcountryTypeList = this.countryTypeList;
        },
        error => {
        }
      )
    }
    else if (this.field.frontendLabel == 'Lead Source') {
      this.LeadSourceYFilter();
      this.getLeadSourceList();
      this.field.eavAttributeOption = [];
      this.leadSourceService.getAllLeadSourceDropDown().subscribe(
        res => {
          this.leadSourceList = res;
          this.leadSourceTypeList = res;
          this.filteredleadSourceTypeList = this.leadSourceTypeList;
        },
        error => {
        }
      )
    }
    else if (this.field.frontendLabel == 'Lead Status') {
      this.field.eavAttributeOption = [];
      this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
        res => {

          let selectedValue = this.group.value.LeadStatus;



          this.leadStatusList = res;
          this.leadStatusTypeList = res;

          if (selectedValue != undefined) {
            if (selectedValue > 0) {
              let index = this.leadStatusList.findIndex(x => x.statusId == selectedValue);

              console.log(index);

              if (index > -1) {
                this.getcreateDynamicForm(this.leadStatusList[index].dynamicFormGroupId);

              }
            }
          }

          this.filteredleadStatusTypeList = this.leadStatusTypeList;
        },
        error => {
        }
      )
      this.LeadStatusYFilter();
      this.getLeadStatusList();

    }

    else if (this.field.frontendLabel == 'Deals Status') {
      this.field.eavAttributeOption = [];
      this.dealStatusService.getAllDealStatusDropDown(1).subscribe(
        res => {

          this.leadStatusList = res;
          this.leadStatusTypeList = res;
          this.filteredleadStatusTypeList = this.leadStatusTypeList;

        },
        error => {
        }
      )
      this.LeadStatusYFilter();
      this.getLeadStatusList();

    }

    else if (this.router.url.includes('/lead') && this.field.frontendLabel == 'Status') {
      this.field.eavAttributeOption = [];
      this.statusService.getAllLeadStatusDropDown(2).subscribe(
        res => {

          this.leadStatusList = res;
          this.leadStatusTypeList = res;
          this.filteredleadStatusTypeList = this.leadStatusTypeList;

        },
        error => {
        }
      )
      this.LeadStatusYFilter();
      this.getLeadStatusList();

    }
    else if (this.field.frontendLabel == 'Layout') {
      this.getCmsList();
      this.CmsYFilter();
      this.field.eavAttributeOption = [];
      this.cmsPageService.getAllCmsDropDown().subscribe(
        res => {
          this.cmsList = res;
          this.cmsTypeList = res;
          this.filteredCmsTypeList = this.cmsTypeList;
        },
        error => {
        }
      )
    }
    else if (this.field.frontendLabel == 'Owner') {
      this.field.eavAttributeOption = [];

      let val: any = localStorage.getItem('userType')

      if (val == null) {
        val = 0;
      } else if (val == 'salesUser') {
        val = 1;
      } else {
        val = 0;
      }
      if (val > 0) {
        console.log(val);
        this.technicianId = val;
        this.display = true;
      } else {


        this.usersService.getAllUserStatusDropDown().subscribe(
          res => {



            this.userList = res;
            this.userTypeList = res;
            this.filtereduserTypeList = this.userTypeList;
          },
          error => {
          }
        )
        this.display = false;

      }

      this.getOwnerList();
      this.LeadOwnerYFilter();

    }
    else if (this.field.frontendLabel == 'Country') {
      this.commonService.getCountryList().subscribe(
        res => {
          this.countryTypeList = res;
          this.filteredcountryTypeList = this.countryTypeList;
        },
        error => {
        }
      )
    }
    else if (this.field.frontendLabel == 'Tax Class') {
      this.taxService.getTaxClassProduct().subscribe(
        res => {
          this.taxClassTypeList = res;
          this.filteredTaxClassList = this.taxClassTypeList;
        },
        error => {
        }
      )
    }

    else if (this.field.frontendLabel == 'Lecture') {
      this.field.eavAttributeOption = [];
      this.lecturerService.getAllLecturerDropDown(2).subscribe(
        data => {
          this.lectureList = data;
          this.lectureTypeList = data;
          this.filteredlectureTypeList = this.lectureTypeList;
        },
        error => {
        }
      )
      this.LectureYFilter();
      this.getAllLecture();


    }

    else if (this.field.frontendLabel == 'Doctor') {
      this.field.eavAttributeOption = [];
      this.doctorService.getAllDoctorDropDown(3).subscribe(
        data => {
          this.doctorList = data;
          this.doctorTypeList = data;
          this.filteredDoctorTypeList = this.doctorTypeList;
        },
        error => {
        }
      )
      this.DoctorYFilter();
      this.getAllDoctor();


    }

    else if (this.field.frontendLabel == 'Priority') {
      this.field.eavAttributeOption = [];
      this.priorityService.getAllPriorityDropDown().subscribe(
        data => {
          this.priorityList = data;
          this.priorityTypeList = data;
          console.log("here");

          this.filteredPriorityTypeList = this.priorityTypeList;
        },
        error => {
        }
      )
      this.PriorityYFilter();
      this.getAllPriority();


    }

    else if (this.field.frontendLabel == 'Tracker') {
      this.field.eavAttributeOption = [];
      this.trackerService.getAllTrackerDropDown().subscribe(
        data => {
          this.trackerList = data;
          this.trackerTypeList = data;
          this.filteredTrackerTypeList = this.trackerTypeList;
        },
        error => {
        }
      )
      this.TrackerYFilter();
      this.getAllTracker();


    }

    else if (this.field.frontendLabel == 'Project') {
      this.field.eavAttributeOption = [];
      this.projectsService.getAllProjectsDropDown().subscribe(
        data => {
          this.projectsList = data;
          this.projectsTypeList = data;
          console.log(this.projectsTypeList);
          this.filteredprojectsTypeList = this.projectsTypeList;
        },
        error => {
        }
      )
      this.ProjectsYFilter();
      this.getAllProjects();


    }

    else if (this.field.frontendLabel == 'Doctors') {
      this.field.eavAttributeOption = [];
      this.doctorService.getAllDoctorDropDown(3).subscribe(
        data => {
          this.doctorList = data;
          this.doctorTypeList = data;
          this.filteredDoctorTypeList = this.doctorTypeList;
        },
        error => {
        }
      )
      this.DoctorYFilter();
      this.getAllDoctor();


    }

    else if (this.field.frontendLabel == 'Form') {
      this.field.eavAttributeOption = [];
      this.dynamicFormGroupService.getAllDynmaicFormDropDown(1).subscribe(
        (res) => {
          this.dynamicFormList = res;
          this.dynamicFormTypeList = this.dynamicFormList;
          this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
        },
        (error) => { }
      );
      this.DoctorYFilter();
      this.getAllDoctor();


    }

    else if (this.field.frontendLabel == 'Category') {
      this.field.eavAttributeOption = [];
      this.catalogPriceRulesService.fetchAlldropdownValueForRule().subscribe(
        data => {
          this.CategoryList = data;
          this.CategoryTypeList = data;
          this.filteredCategoryTypeList = this.CategoryTypeList;
        },
        error => {
        }
      )
      this.categoryYFilter();
      this.getCategoryList();


    }

    // else if (this.field.frontendLabel == 'Product') {
    //   this.field.eavAttributeOption = [];


    // }

    else if (this.field.frontendLabel == 'Supplier') {

      let val: any | null = null;

      const encryptedUserSettings = localStorage.getItem('userSettingsData');

      if (encryptedUserSettings) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
          const userSettings = JSON.parse(decrypted);
          val = userSettings.userType;
        } catch (error) {
          console.error('Error decrypting or parsing userSettingsData:', error);
        }
      }

      if (!val) {
        const encryptedSigninDetails = localStorage.getItem('signinDetails');
        if (encryptedSigninDetails) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
            const signinDetails = JSON.parse(decrypted);
            val = signinDetails.userType;
          } catch (error) {
            console.error('Error decrypting or parsing signinDetails:', error);
          }
        }
      }


      if (val > 0) {

        this.group.value[this.field.attributeCode] = val;
        this.group.patchValue(this.group.value)
        this.supDisabled = true;
      }

      this.supplierService.getAllVendorDropDown(1).subscribe(
        data => {
          this.supplierList = data;

          let object = {
            "id": 0,
            "name": "Default",
            "company": "Default",
            "vatNo": "1992993",
            "gstNo": "31",
            "email": "yeshwanth@calsoftgroup.com",
            "phone": "123",
            "address": "safas",
            "city": "123",
            "state": "safas",
            "postalCode": "1223",
            "country": "Afghanistan",
            "cf1": null,
            "cf2": null,
            "cf3": null,
            "cf4": null,
            "cf5": null,
            "cf6": null,
            "payment_term": 0,
            "logo": "drop-shipping.png",
            "awardPoints": 0,
            "deposit_amount": 0.0,
            "supplierWebsite": "test.com",
            "supplierLatitude": "sasf",
            "supplierLongitude": "12",
            "operationType": null
          }
          this.supplierList.push(object);
          this.supplierTypeList = data;
          this.filteredsupplierTypeList = this.supplierTypeList;

        }
      )

      this.supplierYFilter();
      this.getAllsupplier();
    }

    this.value = this.field.eavAttributeOption;
    this.fieldTypeList = this.value;
  }


  setCategory(event: any, selectedOption: any) {
    if (event.isUserInput) {

      const categoryId = selectedOption;
      this.searchTermValue = "categoryId_txt:" + '*' + categoryId + '*' + "'";
      this.getProduct(this.searchTermValue);
    }
  }

  setCategoryNew(event: any) {

    this.searchTermValue = "categoryId_txt:" + '*' + event + '*' + "'";
    this.getProduct(this.searchTermValue);

  }


  //category

  CategoryTypeList: any;
  filteredCategoryTypeList: any;

  CategoryList: any;
  getCategoryList() {
    this.catalogPriceRulesService.fetchAlldropdownValueForRule().subscribe(
      (res) => {
        this.CategoryList = res['category'];
        let object = [{
          breadCrumpPath: "Spices",
          categoryId: 0,
          categoryName: "None",
          childCount: 2,
          description: "Spices",
          image: null,
          includeInMenu: "1",
          isActive: "0",
          mega: "false",
          metaDescription: "Spices",
          parentId: "2",
          path: "1062",
          pathValue: "1/2/1062",
          position: 0,
          subcategories: [],
          type: "PARENT"
        },
        ]



        this.CategoryList = [...this.CategoryList, ...object];
        this.CategoryTypeList = this.CategoryList;
        this.filteredCategoryTypeList = this.CategoryTypeList;
      },
      (error) => { }
    );
  }

  public categoryFilterControl: UntypedFormControl = new UntypedFormControl();
  categoryYFilter() {
    this.categoryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.categoryFilter();
      });
  }

  protected categoryFilter() {
    if (!this.CategoryTypeList) {
      return;
    }
    let search = this.categoryFilterControl.value;
    if (!search) {
      this.filteredCategoryTypeList = this.CategoryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredCategoryTypeList = this.CategoryTypeList.filter(
      (category) => category['categoryName'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllCategory() {
    this.filteredCategoryTypeList = this.CategoryTypeList;
  }

  //lecture

  lectureList: any = [];
  lectureTypeList: any = [];
  filteredlectureTypeList: any = [];
  lectureControl: UntypedFormControl = new UntypedFormControl();
  lectureFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllLecture() {
    this.filteredlectureTypeList = this.lectureTypeList;
  }

  LectureYFilter() {
    this.lectureFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.lectureFilter();
      });
  }

  protected lectureFilter() {
    if (!this.lectureTypeList) {
      return;
    }
    // get the search keyword
    let search = this.lectureFilterControl.value;
    if (!search) {
      this.filteredlectureTypeList = this.lectureTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredlectureTypeList = this.filteredlectureTypeList.filter(lecture => lecture['company'].toLowerCase().indexOf(search) > -1)
  }

  // Doctor

  doctorList: any = [];
  doctorTypeList: any = [];
  filteredDoctorTypeList: any = [];
  doctorControl: UntypedFormControl = new UntypedFormControl();
  doctorFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllDoctor() {
    this.filteredDoctorTypeList = this.doctorTypeList;
  }

  DoctorYFilter() {
    this.doctorFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.doctorFilter();
      });
  }

  protected doctorFilter() {
    if (!this.doctorTypeList) {
      return;
    }
    // get the search keyword
    let search = this.doctorFilterControl.value;
    if (!search) {
      this.filteredDoctorTypeList = this.doctorTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredDoctorTypeList = this.filteredDoctorTypeList.filter(doctor => doctor['company'].toLowerCase().indexOf(search) > -1)
  }



  filterCountry(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['countryId'] != undefined) {
        filterValue = value['countryName'];
        this.firstFormGroup.patchValue({ countryId: value['countryId'], countryName: value['countryName'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.countryTypeList.filter(option => option.countryName.toLowerCase().includes(filterValue));
  }

  private _filter(value: any): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  getAllCountry() {
    this.filteredcountryTypeList = this.countryTypeList;
  }
  countrYFilter() {
    this.countryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.countryFilter();
      });
  }

  protected countryFilter() {
    if (!this.countryTypeList) {
      return;
    }

    // get the search keyword
    let search = this.countryFilterControl.value;
    if (!search) {
      this.filteredcountryTypeList = this.countryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredcountryTypeList = this.countryTypeList.filter(country => country['countryName'].toLowerCase().indexOf(search) > -1)
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  ////////////////////

  fieldControl: UntypedFormControl = new UntypedFormControl();
  fieldFilterControl: UntypedFormControl = new UntypedFormControl();

  filterField(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['optionId'] != undefined) {
        filterValue = value['optionId'];
        this.firstFormGroup.patchValue({ optionId: value['optionId'], field: value['optionId'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.fieldTypeList.filter(option =>

      option.eavAttributeOptionValue[0].value.toLowerCase().includes(filterValue));
  }

  getAllField() {
    this.fieldTypeList = this.value;
  }
  fielDFilter() {
    this.fieldFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.fieldFilter();
      });
  }

  protected fieldFilter() {
    if (!this.fieldTypeList) {
      return;
    }
    let search = this.fieldFilterControl.value;
    if (!search) {
      this.fieldTypeList = this.value.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.fieldTypeList = this.value.filter(field => field.eavAttributeOptionValue[0].value.toLowerCase().indexOf(search) > -1)
  }

  //////matselect tax class

  filterTaxclass(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['classId'] != undefined) {
        filterValue = value['className'];
        this.firstFormGroup.patchValue({ classId: value['classId'], className: value['className'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.taxClassTypeList.filter(option => option.className.toLowerCase().includes(filterValue));
  }


  // private _filter(value: any): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  getAllTaxclass() {
    this.filteredTaxClassList = this.taxClassTypeList;
  }
  taxclassYFilter() {
    this.taxclassFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.taxclassFilter();
      });
  }

  protected taxclassFilter() {
    if (!this.taxClassTypeList) {
      return;
    }

    // get the search keyword
    let search = this.taxclassFilterControl.value;
    if (!search) {
      this.filteredTaxClassList = this.taxClassTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTaxClassList = this.taxClassTypeList.filter(country => country['className'].toLowerCase().indexOf(search) > -1)
  }
  booleanField: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  ///supplier

  //country
  supplierList: any = [];
  supplierTypeList: any = [];
  filteredsupplierTypeList: any = [];
  supplierControl: UntypedFormControl = new UntypedFormControl();
  supplierFilterControl: UntypedFormControl = new UntypedFormControl();
  options: any;



  getAllsupplier() {
    this.filteredsupplierTypeList = this.supplierTypeList;
  }

  supplierYFilter() {
    this.supplierFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.supplierFilter();
      });
  }

  protected supplierFilter() {
    if (!this.supplierTypeList) {
      return;
    }
    // get the search keyword
    let search = this.supplierFilterControl.value;
    if (!search) {
      this.filteredsupplierTypeList = this.supplierTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredsupplierTypeList = this.supplierTypeList.filter(supplier => supplier['company'].toLowerCase().indexOf(search) > -1)
  }




  //lead Source

  leadSourceList: any;
  leadSourceTypeList: any;
  filteredleadSourceTypeList: any;

  public leadSourceFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadSourceList() {

    this.filteredleadSourceTypeList = this.leadSourceTypeList;
  }

  LeadSourceYFilter() {
    this.leadSourceFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadSourceFilter();
      });
  }


  protected LeadSourceFilter() {
    if (!this.leadSourceTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadSourceFilterControl.value;
    if (!search) {
      this.filteredleadSourceTypeList = this.leadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadSourceTypeList = this.leadSourceTypeList.filter(source => source['sourceName']
      .toLowerCase().indexOf(search) > -1)
  }


  //lead status

  leadStatusList: any;
  leadStatusTypeList: any;
  filteredleadStatusTypeList: any;

  public leadStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.filteredleadStatusTypeList = this.leadStatusTypeList;
  }

  LeadStatusYFilter() {
    this.leadStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.leadStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadStatusFilterControl.value;
    if (!search) {
      this.filteredleadStatusTypeList = this.leadStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadStatusTypeList = this.leadStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }


  //owner name

  userList: any;
  userTypeList: any;
  filtereduserTypeList: any;

  public userOwnerFilterControl: UntypedFormControl = new UntypedFormControl();

  getOwnerList() {

    this.filtereduserTypeList = this.userTypeList;
  }

  LeadOwnerYFilter() {
    this.userOwnerFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeaduserOwnerFilter();
      });
  }


  protected LeaduserOwnerFilter() {
    if (!this.userTypeList) {
      return;
    }
    // get the search keyword
    let search = this.userOwnerFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }


  //Page
  public cmsFilterControl: UntypedFormControl = new UntypedFormControl();

  cmsList: any;
  cmsTypeList: any;
  filteredCmsTypeList: any;

  getCmsList() {
    this.filteredCmsTypeList = this.cmsTypeList;
  }

  CmsYFilter() {
    this.cmsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.CmsFilter();
      });
  }


  protected CmsFilter() {
    if (!this.cmsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.cmsFilterControl.value;
    if (!search) {
      this.filteredCmsTypeList = this.cmsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredCmsTypeList = this.cmsTypeList.filter(cms => cms['title']
      .toLowerCase().indexOf(search) > -1)
  }

  getAllCmsSet() {
    this.filteredCmsTypeList = this.cmsTypeList;
  }
  priceControl = new FormControl(0.0);

  public page: any = Constant.PAGE;
  public size: any = 1000;
  sortParam: any = 'entityId' + "," + Constant.Dsc;
  productList: any = [];
  getProduct(searchTerm: any) {
    this.spinner = true;
    this.productService.getProductByCategoryId(searchTerm).subscribe(
      res => {
        this.spinner = false;
        this.productList = res;


        this.setPrice();


      },
      error => {
        this.spinner = false;
      }
    )
  }

  setPrice() {
    if (this.productList.length > 0) {

      let key = 'Product';


      if (this.group.get(key)) {
        if (this.group.get(key) != null) {

          console.log(this.group.value['Product']);

          let index = this.productList.findIndex(x => x.entityId == parseInt(this.group.value['Product']));

          if (index > -1) {
            let price = this.productList[index].price;
            this.priceControl.setValue(price);
          }

        }
      }

    }
  }


  setPriceSelection(event, productId) {
    if (event.isUserInput != false) {

      if (this.productList.length > 0) {

        let index = this.productList.findIndex(x => x.entityId == parseInt(productId));

        if (index > -1) {
          let price = this.productList[index].price;
          this.priceControl.setValue(price);
        }

      }
    }

  }


  //

  createDynamicForm(event, formGroupId) {
    if (event.isUserInput != false) {

      this.getcreateDynamicForm(formGroupId)
    }

  }

  getcreateDynamicForm(formGroupId) {

    this.getFormArray(formGroupId)

  }

  init: boolean = false;


  regConfig: any[] = [];

  getFormArray(formGroupId) {
    this.init = false;
    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.regConfig = value;
        this.init = true;
        this.newType = 2;
      }


    });
  }

  onFormSubmitted(event) {


    delete event['LeadStatus'];

    const firstValue = Object.values(event)[0];

    if (firstValue !== undefined && firstValue != null) {
      const secondaryLeadStatusControl = this.group.get('SecondaryLeadStatus');

      if (secondaryLeadStatusControl) {
        secondaryLeadStatusControl.setValue(firstValue);
      } else {
        console.error("Control 'secondaryLeadStatus' does not exist in the form group.");
      }
    }
    event['LeadStatus'] = this.group.value.LeadStatus;

    for (const key in event) {
      if (event.hasOwnProperty(key) && this.group.get(key)) {
        if (event[key] != null) {

          this.group.get(key).setValue(event[key]);
        }
      }

    }



  }


  //contact form

  dynamicFormTypeList: any;
  filtereddynamicFormTypeList: any;

  public dynamicFormFilterControl: UntypedFormControl = new UntypedFormControl();

  dynamicFormList: any;
  getdynamicFormList() {
    this.dynamicFormGroupService.getAllDynmaicFormDropDown(1).subscribe(
      (res) => {
        this.dynamicFormList = res;
        this.dynamicFormTypeList = this.dynamicFormList;
        this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
      },
      (error) => { }
    );
  }

  dynmaicFormYFilter() {
    this.dynamicFormFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.dynamicFilter();
      });
  }

  protected dynamicFilter() {
    if (!this.dynamicFormTypeList) {
      return;
    }
    let search = this.dynamicFormFilterControl.value;
    if (!search) {
      this.filtereddynamicFormTypeList = this.dynamicFormTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filtereddynamicFormTypeList = this.dynamicFormTypeList.filter(
      (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
    );
  }

  getAlldynamicForm() {
    this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
  }


  // Tracker

  trackerList: any = [];
  trackerTypeList: any = [];
  filteredTrackerTypeList: any = [];
  trackerControl: UntypedFormControl = new UntypedFormControl();
  trackerFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTracker() {
    this.filteredTrackerTypeList = this.trackerTypeList;
  }

  TrackerYFilter() {
    this.trackerFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.trackerFilter();
      });
  }

  protected trackerFilter() {
    if (!this.trackerTypeList) {
      return;
    }
    // get the search keyword
    let search = this.trackerFilterControl.value;
    if (!search) {
      this.filteredTrackerTypeList = this.trackerTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTrackerTypeList = this.filteredTrackerTypeList.filter(tracker => tracker['trackerName'].toLowerCase().indexOf(search) > -1)
  }

  // Projects

  projectsList: any = [];
  projectsTypeList: any = [];
  filteredprojectsTypeList: any = [];
  projectsControl: UntypedFormControl = new UntypedFormControl();
  projectsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllProjects() {
    this.filteredprojectsTypeList = this.projectsTypeList;
  }

  ProjectsYFilter() {
    this.projectsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.projectsFilter();
      });
  }

  protected projectsFilter() {
    if (!this.projectsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.projectsFilterControl.value;
    if (!search) {
      this.filteredprojectsTypeList = this.projectsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredprojectsTypeList = this.filteredprojectsTypeList.filter(project => project['name'].toLowerCase().indexOf(search) > -1)
  }


  // Priority

  priorityList: any = [];
  priorityTypeList: any = [];
  filteredPriorityTypeList: any = [];
  priorityControl: UntypedFormControl = new UntypedFormControl();
  PriorityFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllPriority() {
    this.filteredPriorityTypeList = this.priorityTypeList;
  }

  PriorityYFilter() {
    this.PriorityFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.priorityFilter();
      });
  }

  protected priorityFilter() {
    if (!this.priorityTypeList) {
      return;
    }
    // get the search keyword
    let search = this.PriorityFilterControl.value;
    if (!search) {
      this.filteredPriorityTypeList = this.priorityTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPriorityTypeList = this.filteredPriorityTypeList.filter(priority => priority['priorityName'].toLowerCase().indexOf(search) > -1)
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
